import { useParams, Link } from 'react-router-dom';
import { articles, categories, getArticlesByCategory } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOMeta from '@/components/feature/SEOMeta';
import { generateBreadcrumbSchema } from '@/components/feature/SEOMeta';
import { useState, useEffect } from 'react';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'football');
  const categoryArticles = getArticlesByCategory(activeSlug);
  const currentCategory = categories.find((c) => c.slug === activeSlug);

  useEffect(() => {
    if (slug && slug !== activeSlug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const handleCategoryChange = (newSlug: string) => {
    setActiveSlug(newSlug);
    window.history.pushState(null, '', `/category/${newSlug}`);
  };

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory?.name || '' },
  ];

  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumbItems);

  const pageTitle = currentCategory
    ? `${currentCategory.name}赛事资讯 - 乐球体育`
    : '赛事分类 - 乐球体育';
  const pageDescription = currentCategory
    ? `乐球体育为您提供最新${currentCategory.name}赛事资讯、实时比分、数据分析与精彩集锦。关注乐球体育${currentCategory.name}频道，获取第一手${currentCategory.name}新闻。`
    : '';

  return (
    <>
      <SEOMeta type="breadcrumb" data={breadcrumbItems as unknown as Record<string, unknown>} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={`乐球体育${currentCategory?.name || ''},乐球体育${currentCategory?.name || ''}赛事,${currentCategory?.name || ''}资讯`} />
      <link rel="canonical" href={`https://www.leqiusports.com/category/${activeSlug}`} />

      <main>
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
          <Breadcrumb items={breadcrumbItems} />

          <section className="py-4">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-primary-500 rounded-xl flex items-center justify-center">
                <i className={`${currentCategory?.icon || 'ri-medal-line'} text-white text-lg`}></i>
              </div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {currentCategory?.name}赛事资讯
              </h1>
            </div>
            <p className="text-foreground-500 text-sm mb-6">
              乐球体育为您呈现最新{currentCategory?.name}赛事资讯，涵盖{currentCategory?.name}实时比分、赛事分析、球员动态等全方位内容。共 {categoryArticles.length} 篇文章。
            </p>

            <CategoryTabs
              categories={categories}
              activeSlug={activeSlug}
              onSelect={handleCategoryChange}
            />
          </section>

          <section className="py-6">
            {categoryArticles.length > 0 ? (
              <div className="space-y-4">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 bg-background-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">暂无相关文章</p>
              </div>
            )}
          </section>
        </div>
      </main>
    </>
  );
}